/**
 * Created by shaohuan on 2017/4/12.
 * 商品
 */
import HttpUtil from '../HttpUtil'
let configDomain = process.env.DOMAIN
const orderAPI = {
  /**
   * 订单列表
   */
  getList(params) {
    let postUrl = configDomain + '/buyer/order/list'
    // let postUrl = '../static/mock/order.json'
    return HttpUtil.get(postUrl, params)
  },
  getInfo(params) {
    let postUrl = configDomain + '/buyer/order/info'
    // let postUrl = '../static/mock/orderinfo.json'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 物流公司列表
   */
  getCompanys(params) {
    let postUrl = configDomain + '/bshop/config/dict/list'
    return HttpUtil.get(postUrl, params)
  },
  orderDetail(params) {
    return HttpUtil.get(`${configDomain}/buyer/order/group/detail`, params)
  },
  /**
   * 发货
   */
  doDeliver(params) {
    let postUrl = configDomain + '/bshop/order/logistics/delivery'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 修改物流
   */
  doModLogist(params) {
    let postUrl = configDomain + '/bshop/order/logistics/update'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 修改价格
   */
  doModPrice(params) {
    let postUrl = configDomain + '/bshop/order/price/update'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 物流信息
   */
  getLogistList(params) {
    let postUrl = configDomain + '/order/waybillprocess/list'
    // let postUrl = '../static/mock/logist.json'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 关闭订单
   */
  closeOrder(params) {
    let postUrl = configDomain + '/buyer/order/close'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 收货地址列表
   */
  getAddress(params) {
    let postUrl = configDomain + '/buyer/person/address/list'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 新增收货地址
   */
  addAddress(params) {
    let postUrl = configDomain + '/buyer/person/address/add'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 编辑收货地址
   */
  editAddress(params) {
    let postUrl = configDomain + '/buyer/person/address/update'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 删除收货地址
   */
  shiftAddress(params) {
    let postUrl = configDomain + '/buyer/person/address/delete'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 收货地址详情地址
   */
  detailAddress(params) {
    let postUrl = configDomain + '/buyer/person/address/detail'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 默认收货地址
   */
  defaultAddress(params) {
    let postUrl = configDomain + '/buyer/person/address/setdefault'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 下拉国家列表
   */
  countryList(params) {
    let postUrl = configDomain + '/bshop/config/country/listall'
    return HttpUtil.get(postUrl, params)
  },
  prePayOrder(data) {
    return HttpUtil.get(`${configDomain}/buyer/order/paypal/quickpay/create`, data)
  },
  /**
   * 个人信息
   */
  getBasicInfo(params) {
    let postUrl = configDomain + '/buyer/person/account/info'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 修改名字
   */
  changeName(params) {
    let postUrl = configDomain + '/buyer/person/account/nick/change'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 修改密码
   */
  changePassword(params) {
    let postUrl = configDomain + '/buyer/person/account/changepasswd'
    return HttpUtil.post(postUrl, params)
  },
  /**
   * 获取浏览记录
   */
  getVisitRecord(params) {
    let postUrl = configDomain + '/buyer/product/visit/record/list'
    return HttpUtil.get(postUrl, params)
  },
  /**
   * 删除浏览记录
   */
  deleteVisitRecord(params) {
    let postUrl = configDomain + '/buyer/product/delete/visit/record'
    return HttpUtil.post(postUrl, params)
  },
  //faceBook账号绑定
  bindFaceBook(params) {
    let postUrl = configDomain + '/buyer/fblogin/bindaccount'
    return HttpUtil.get(postUrl, params)
  },
  //faceBook账号绑定信息
  getBindBasicInfo(params) {
    let postUrl = configDomain + '/buyer/fbbind/detail'
    return HttpUtil.get(postUrl, params)
  },
  //faceBook账号解除绑定
  unbindFaceBook(params) {
    let postUrl = configDomain + '/buyer/fbbind/removebind'
    return HttpUtil.post(postUrl, params)
  },
  // 删除订单
  deleteOrder(params) {
    let postUrl = configDomain + '/buyer/order/delete'
    return HttpUtil.post(postUrl, params)
  },
  // 确认收货接口
  confirmReceipt(params) {
    let postUrl = configDomain + '/buyer/order/logistics/receive'
    return HttpUtil.post(postUrl, params)
  },
  // 订单总数统计
  getOrderCount() {
    let postUrl = configDomain + '/buyer/order/count'
    return HttpUtil.get(postUrl)
  },
  /**
  * // 根据域名获取店铺信息
  * @param  {[type]} params [description]
  * @return {[type]}        [description]
  */
  getShopByDomain(params) {
    let postUrl = configDomain + '/bshop/config/domain/get/bydomain'
    return HttpUtil.get(postUrl, params)
  },
  getWaybillprocessV2List(params) {
    return HttpUtil.get(`${configDomain}/order/waybillprocess/v2/list`, params)
  },
  getCommentList(params) {
    return HttpUtil.get(`${configDomain}/buyer/order/comment/list/v2`, params)
  },
  setComment(data) {
    return HttpUtil.post(`${configDomain}/buyer/order/comment/add/v2`, data)
  },
  currencyList() {
    return HttpUtil.get(`${configDomain}/buyer/currency/list`)
  },
  enquiryList(params) {
    return HttpUtil.get(`${configDomain}/buyer/product/enquiry/list`, params)
  },
  enquiryDelete(params) {
    return HttpUtil.get(`${configDomain}/buyer/product/enquiry/delete`, params)
  },
  // 问题列表接口
  getBuyerQAList(params) {
    return HttpUtil.get(`${configDomain}/buyer/product/qa/buyerQAList`, params)
  },
  // 买家修改问题接口
  editQuestion(params) {
    return HttpUtil.post(`${configDomain}/buyer/product/qa/editQuestion`, params)
  },
  // 买家删除问题接口
  deleteQuestion(params) {
    return HttpUtil.get(`${configDomain}/buyer/product/qa/deleteQuestion`, params)
  }
}

export default orderAPI
